import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IAttachmentContentProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useAttachmentContext
} from "../../context";
import {
    warnOnce
} from "../../../../utils/development";

const AttachmentContent: FC<IAttachmentContentProps> = ({
    customTheme,
    children,
    style,
    ...props
}) => {
    const context = useAttachmentContext();

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme ?? context?.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        orientation: context?.orientation ?? "horizontal",
        spaces
    });

    if(!context) {
        warnOnce({
            message: "Attachment.Content: it must be rendered inside an Attachment."
        });

        return null;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default AttachmentContent;
